module.exports = __webpack_public_path__ + "static/img/solution-case-m.2a5c330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-case-m.png
// module id = 1SX0
// module chunks = 1